module.exports = __webpack_public_path__ + "static/media/icon.d41b85bc.svg";